import _ from "lodash";


export const INPUT_ERROR_MSG = {
  reportName: null,
  fbAdAccounts: null,
  dateRange: null,
  email: null,
  emailTemplate: null,
  optionFieldName: null,
  reportType: null,
  selectFields: null,
  excelSheet: null,
  campaignGoals: null
}

export const DOWNLOAD_ERROR_MSG = {
  reportName: null,
  fbAdAccounts: null,
  optionFieldName: null,
  reportDateRange: null,
  selectFields: null,
  excelSheet: null,
  campaignGoals: null
}

export const checkLineForm = (data) => {
  const {
    reportName,
    fbAdAccounts,
    emailList,
    emailTemplate,
    emailTemplateType,
    sendTimeData,
    selectedGeneralFields,
    selectedCustomFields,
    excelSheetSelected,
    campaignGoalsSelected,
  } = data;

  let isTab1Error = false;
  let isTab2Error = false;
  let errorMsg = {
    reportName: null,
    fbAdAccounts: null,
    dateRange: null,
    email: null,
    emailTemplate: null,
    optionFieldName: null,
    reportType: null,
    selectFields: null,
    excelSheet: null,
    campaignGoals: null
  };

  if (reportName === '') {
    errorMsg.reportName = '請輸入名稱';
    isTab1Error = true;
  } else {
    errorMsg.reportName = null;
  }

  if (!fbAdAccounts.length) {
    errorMsg.fbAdAccounts = '請選擇廣告帳號';
    isTab1Error = true;
  } else {
    errorMsg.fbAdAccounts = null;
  }

  // if (!emailList.length || emailList[0] === 'example@gmail.com') {
  //   errorMsg.email = '請輸入寄送對象';
  //   isTab2Error = true;
  // } else {
  //   errorMsg.email = null;
  // }

  const totalFields = _.concat(selectedGeneralFields, selectedCustomFields);
  const removeRepeatFieldName = _.uniqBy(totalFields, 'name');

  if (totalFields.length !== removeRepeatFieldName.length) {
    errorMsg.optionFieldName = '欄位名稱不可重複';
    isTab1Error = true;
  } else {
    errorMsg.optionFieldName = null;
  }

  if (!excelSheetSelected.length) {
    errorMsg.excelSheet = '請設定報表Excel分頁';
    isTab1Error = true;
  } else {
    errorMsg.excelSheet = null;
  }

  if (!campaignGoalsSelected.length) {
    errorMsg.campaignGoals = '請設定要匯出的廣告目標報表';
    errorMsg.optionFieldName = null;
    isTab1Error = true;
  } else {
    errorMsg.campaignGoals = null;
  }

  if (!sendTimeData.reportType.length) {
    errorMsg.reportType = '請設定寄送週期';
    isTab2Error = true;
  } else {
    errorMsg.reportType = null;
  }

  if (!emailTemplateType || !emailTemplate) {
    errorMsg.emailTemplate = '請設定信件指標';
    isTab2Error = true;
  } else {
    errorMsg.emailTemplate = null;
  }

  return {
    isTab1Error,
    isTab2Error,
    errorMsg
  }

}

export const checkLineDownloadForm = (data) => {
  const { reportName, fbAdAccounts, selectedGeneralFields, selectedCustomFields, excelSheetSelected, campaignGoalsSelected } = data;
  let downloadErrorMsg = {
    reportName: null,
    fbAdAccounts: null,
    optionFieldName: null,
    reportDateRange: null,
    selectFields: null,
    excelSheet: null,
    campaignGoals: null
  };

  if (reportName === '') {
    downloadErrorMsg.reportName = '請輸入名稱';
  } else {
    downloadErrorMsg.reportName = null;
  }

  if (!fbAdAccounts.length) {
    downloadErrorMsg.fbAdAccounts = '請選擇廣告帳號';
  } else {
    downloadErrorMsg.fbAdAccounts = null;
  }

  const totalFields = _.concat(selectedGeneralFields, selectedCustomFields);
  const removeRepeatFieldName = _.uniqBy(totalFields, 'name');

  if (totalFields.length !== removeRepeatFieldName.length) {
    downloadErrorMsg.optionFieldName = '欄位名稱不可重複';
  } else {
    downloadErrorMsg.optionFieldName = null;
  }

  if (!excelSheetSelected.length) {
    downloadErrorMsg.excelSheet = '請設定報表Excel分頁';
  } else {
    downloadErrorMsg.excelSheet = null;
  }

  if (!campaignGoalsSelected.length) {
    downloadErrorMsg.campaignGoals = '請設定要匯出的廣告目標報表';
    downloadErrorMsg.optionFieldName = null;
  } else {
    downloadErrorMsg.campaignGoals = null;
  }

  return { downloadErrorMsg }
}